import React, { useState, useCallback } from "react"
import TabPanel from "src/components/TabPanel"
import CrudModal from "src/components/CrudModal"
import TabsCrudModal from "src/components/TabsCrudModal"
import Input from "@infotech/uikit-input"
import EntityListTable from "src/components/EntityListTable"
import { P } from "@infotech/uikit-text"
import { Box } from "@infotech/uikit-grid"
import { CleanButton } from "@infotech/uikit-button"
import { SearchIcon } from "@infotech/uikit-icons"
import FilterFilled from "src/icons/filterFilled.svg"
import InternalServerErrorPage from "src/components/pages/InternalServerError"
import Filter from "src/icons/filter.svg"
import get from "lodash/get"
import cn from "classnames"
import getWordByModelName from "src/helpers/text/getWordByModelName"
import useFilter from "./hocs/useFilter"
import styles from "./styles.css"

const alwaysTrue = () => true

export default props => {
  const {
    entities: { totalCount, pending: entitiesPending, model, data, error },
    noFooter,
    tabConfig,
    dataForTabs,
    newItem,
    submitForm,
    resetForm,
    match: {
      params: { id },
    },
    workspace: {
      labels: { pending: workspacePending, dirty, invalid },
    },
    onChange,
    columns,
    EntityEditor,
    FilterEditor,
    isOnlySearchInputFilter,
    fullHeight,
    fullWidth,
    modalWidth,
    baseUri,
    history,
    dispatch,
    queryPagination,
    setQuery,
    disableCreate = false,
    disableEdit = false,
    disableDelete = false,
    canEdit = alwaysTrue,
    canDelete = alwaysTrue,
    isValidId,
  } = props
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const toggleFilterModal = useCallback(
    () => setIsFilterModalOpen(!isFilterModalOpen),
    [],
  )

  const {
    shouldShowResetFilter,
    nameState,
    handleSearchInputChange,
    onFilterOk,
    onFilterCancel,
    resetFilter,
  } = useFilter({
    query: queryPagination,
    setQuery,
    setIsFilterModalOpen,
  })
  // Выбирать текущую энтитю из списка - костыль, но по другому сделать слишком сложно
  const selectedEntity = data.find(one => one[model.primaryKey] === id)
  const disableModalSubmit =
    (disableEdit || !canEdit(selectedEntity)) && id !== `new`

  if (error) {
    const status = get(error, `data.status`)
    const errorCode = get(error, `data.errorCode`)
    const errorText = get(error, `data.exception`)
    if (
      status === 500 &&
      (errorCode === `planner.context.base.context.not.available` ||
        errorCode === `planner.context.accessible.contexts.not.available`)
    ) {
      return <InternalServerErrorPage errorText={errorText} />
    }
  }

  return (
    <div>
      <TabPanel
        onAdd={newItem}
        addButtonTooltipText={`Добавить ${getWordByModelName(model.name)}`}
        disableAdd={disableCreate}
        onFilter={toggleFilterModal}
      >
        {(FilterEditor || isOnlySearchInputFilter) && (
          <Box flex grow justify="space-between">
            <Box flex p="1md" center w="330px">
              <div data-testid="entity-list-search-input">
                <Input
                  className={styles.SearchInput}
                  placeholder={`Введите название ${getWordByModelName(
                    model.name,
                    true,
                  )} для поиска`}
                  icon={SearchIcon}
                  onChange={handleSearchInputChange}
                  value={nameState}
                />
              </div>
            </Box>
            {!isOnlySearchInputFilter && (
              <Box flex p="1md" center>
                {shouldShowResetFilter && (
                  <CleanButton
                    className={cn(styles.ResetButton, styles.Button)}
                    onClick={resetFilter}
                  >
                    <P className={styles.ResetFilter}>Сбросить</P>
                  </CleanButton>
                )}
                <CleanButton
                  onClick={toggleFilterModal}
                  className={cn(styles.Button)}
                >
                  {shouldShowResetFilter ? (
                    <FilterFilled
                      className={styles.FilledFilterIcon}
                      size="medium"
                      color="#2880ff"
                    />
                  ) : (
                    <Filter className={styles.FilterIcon} size="medium" />
                  )}
                </CleanButton>
              </Box>
            )}
          </Box>
        )}
      </TabPanel>
      <EntityListTable
        columns={columns}
        data={data}
        totalCount={totalCount}
        pending={entitiesPending || workspacePending}
        pageChangeHandler={onChange}
        model={model}
        baseUri={baseUri}
        history={history}
        dispatch={dispatch}
        query={queryPagination}
        setQuery={setQuery}
        disableDelete={disableDelete}
        canDelete={canDelete}
      />
      {!!id && tabConfig && (
        <TabsCrudModal
          paramsId={id}
          dirty={dirty}
          history={history}
          tabConfig={tabConfig}
          dataForTabs={dataForTabs}
          id={id}
        />
      )}
      {EntityEditor ? (
        <CrudModal
          id={id}
          isValidId={isValidId}
          submitHandler={submitForm}
          disableSubmit={disableModalSubmit}
          resetHandler={resetForm}
          dirty={dirty}
          invalid={invalid}
          pending={entitiesPending}
          isOpen={!!id && !tabConfig}
          fullHeight={fullHeight}
          fullWidth={fullWidth}
          width={modalWidth}
          modelName={model.name}
          noFooter={noFooter}
          history={history}
        >
          {({ overrideModalConf, resetModalConf }) => (
            <EntityEditor
              id={id === `new` ? false : id}
              overrideModalConf={overrideModalConf}
              resetModalConf={resetModalConf}
            />
          )}
        </CrudModal>
      ) : null}
      {FilterEditor && !isOnlySearchInputFilter && (
        <FilterEditor
          isOpen={isFilterModalOpen}
          onOk={onFilterOk}
          onCancel={onFilterCancel}
          query={queryPagination.filter}
          modelName={model.name}
        />
      )}
    </div>
  )
}
